// hooks/useAlert.js
import React, { createContext, useState, useContext, useCallback } from 'react';
import ReactDOM from 'react-dom';
import CommonAlertPopup from '../common/components/CommonAlertPopup';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alertData, setAlertData] = useState(null);

  const showAlert = useCallback(
    ({
      type = 'warning',
      title = 'Alert',
      message = '',
      confirmText = 'Yes',
      cancelText = 'No',
      onClose = () => {},
      onConfirm = () => {},
      isConfirm = true,
      isCancel = true,
      form = false,
      moreWidth = false
    }) =>
      new Promise((resolve) => {
        const handleClose = () => {
          setAlertData(null);
          onClose();
          resolve(false);
        };

        const handleConfirm = () => {
          setAlertData(null);
          onConfirm();
          resolve(true);
        };

        setAlertData({
          show: true,
          type,
          title,
          message,
          confirmText,
          cancelText,
          onClose: handleClose,
          onConfirm: handleConfirm,
          isConfirm,
          isCancel,
          form,
          moreWidth
        });
      }),
    []
  );

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      {alertData && ReactDOM.createPortal(<CommonAlertPopup {...alertData} />, document.body)}
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
